<form [formGroup]="deviceSwopForm" (ngSubmit)="onDeviceSwopSubmit()">
  <div class="grid formgrid p-fluid justify-content-center align-items-center">
    <div class="field w-12 col-12 md:col-6">
      <p class="font-normal text-600">
        <span class="text-primary font-medium">TAKE NOTE:</span> Swopping devices could result in a
        service interruption while the new device is being provisioned. Please ensure that the new
        device is compatible with the customer's existing setup.
      </p>
    </div>

    <div class="field w-12 col-12 md:col-6">
      <label class="text-lg font-medium" for="currentSerialNumber">Current Serial Number</label>
      <input
        id="currentSerialNumber"
        type="text"
        pInputText
        formControlName="current_device_serial_number"
        readonly
        class="w-full"
      />
    </div>
    <div class="field w-12 col-12 md:col-6">
      <label class="text-lg font-medium" for="newSerialDropdown">New Device</label>
      <p-dropdown
        id="newSerialDropdown"
        formControlName="new_device_serial_number"
        [options]="availableDeviceOptions"
        [filter]="true"
        filterBy="label,serial"
        optionLabel="label"
        optionValue="serial"
        [showClear]="true"
        (onFilter)="onDeviceFilter($event.filter)"
        appendTo="body"
        placeholder="Select an available device"
        emptyMessage="No devices found"
        class="w-full"
      >
        <ng-template let-option pTemplate="item">
          <div class="flex flex-column">
            <span class="font-semibold text-900">{{ option.serial }}</span>
            <small class="text-600" *ngIf="option.label && option.label !== option.serial">
              {{ option.label }}
            </small>
          </div>
        </ng-template>
        <ng-template let-selectedOption pTemplate="selectedItem">
          <div class="flex flex-column">
            <span class="font-semibold text-900">{{ selectedOption?.serial }}</span>
            <small
              class="text-600"
              *ngIf="selectedOption?.label && selectedOption?.label !== selectedOption?.serial"
            >
              {{ selectedOption?.label }}
            </small>
          </div>
        </ng-template>
      </p-dropdown>
      <div class="mt-2 text-600" *ngIf="isLoadingDevices">
        <i class="pi pi-spin pi-spinner mr-2"></i>Loading available devices...
      </div>
      <div
        class="mt-2 text-600"
        *ngIf="!isLoadingDevices && !deviceLoadError && availableDeviceOptions.length === 0"
      >
        No available devices were found. Please verify device statuses.
      </div>
      <div class="mt-2 text-red-500" *ngIf="deviceLoadError">
        {{ deviceLoadError }}
      </div>
      <small
        class="p-error"
        *ngIf="
          deviceSwopForm.get('new_device_serial_number')?.invalid &&
          (deviceSwopForm.get('new_device_serial_number')?.dirty ||
            deviceSwopForm.get('new_device_serial_number')?.touched)
        "
      >
        New serial number is required.
      </small>
    </div>
    <button
      *appHasPermission="'subscriptions.change_device'"
      pButton
      type="submit"
      label="Swop Device"
      class="p-button p-button-success"
    ></button>
  </div>
</form>
